import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { EmptyComponent } from './layout/empty/empty.component';
import { PrivacidadRedirectComponent } from './privacidad-redirect/privacidad-redirect.component';
import { CiagComponent } from './ciag/ciag.component';
import { PrivacyComponent } from './privacy/privacy.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'innovacion-gubernamental',
        component: EmptyComponent
      },
      {
        path: 'direcciones',
        component: EmptyComponent
      }
    ]
  },
  { path: 'home', component: HomeComponent },
  { path: 'privacidad', component: PrivacyComponent },
  { path: 'ciag', component: CiagComponent },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
